import React from 'react';

// Ancient, legendary, sacred geometry inspired icons
// CUSTOM ICONS - Never use common icons

// Sacred Mandala - Main logo icon
export const MandalaIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Outer ring */}
    <circle cx="50" cy="50" r="45" stroke="currentColor" strokeWidth="1.5" fill="none" opacity="0.3" />
    <circle cx="50" cy="50" r="40" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.5" />
    
    {/* Inner sacred geometry */}
    <circle cx="50" cy="50" r="30" stroke="currentColor" strokeWidth="1.5" fill="none" />
    
    {/* Central flower of life pattern */}
    <circle cx="50" cy="35" r="12" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    <circle cx="39" cy="50" r="12" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    <circle cx="61" cy="50" r="12" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    <circle cx="50" cy="65" r="12" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    <circle cx="39" cy="40" r="12" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    <circle cx="61" cy="40" r="12" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    <circle cx="39" cy="60" r="12" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    <circle cx="61" cy="60" r="12" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    
    {/* Center */}
    <circle cx="50" cy="50" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="50" cy="50" r="3" fill="currentColor" />
    
    {/* Cardinal rays */}
    <line x1="50" y1="5" x2="50" y2="15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="50" y1="85" x2="50" y2="95" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="5" y1="50" x2="15" y2="50" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="85" y1="50" x2="95" y2="50" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    
    {/* Diagonal rays */}
    <line x1="14" y1="14" x2="22" y2="22" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.7" />
    <line x1="86" y1="14" x2="78" y2="22" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.7" />
    <line x1="14" y1="86" x2="22" y2="78" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.7" />
    <line x1="86" y1="86" x2="78" y2="78" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.7" />
  </svg>
);

// Golden Spiral - Represents growth and nature
export const GoldenSpiralIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    <path
      d="M50 50 C50 30 70 10 90 10 C90 30 90 50 70 70 C50 90 10 90 10 50 C10 20 30 10 50 10 C65 10 75 25 75 40 C75 55 65 65 50 65 C40 65 35 55 35 50 C35 42 42 38 50 38 C55 38 58 42 58 47"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      fill="none"
    />
    <circle cx="50" cy="50" r="3" fill="currentColor" />
  </svg>
);

// Tree of Life - Ancient symbol
export const TreeOfLifeIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Trunk */}
    <path
      d="M50 95 L50 55"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
    {/* Roots */}
    <path
      d="M50 95 C40 90 30 95 25 100"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M50 95 C60 90 70 95 75 100"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      fill="none"
    />
    {/* Main branches */}
    <path
      d="M50 55 C30 50 15 35 20 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M50 55 C70 50 85 35 80 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M50 55 C50 40 50 20 50 5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      fill="none"
    />
    {/* Leaves/circles */}
    <circle cx="20" cy="15" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="50" cy="5" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="80" cy="15" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="30" cy="35" r="6" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    <circle cx="70" cy="35" r="6" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
  </svg>
);

// Vesica Piscis - Sacred geometry
export const VesicaIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    <circle cx="35" cy="50" r="30" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="65" cy="50" r="30" stroke="currentColor" strokeWidth="1.5" fill="none" />
    {/* Inner vesica shape highlight */}
    <path
      d="M50 20 C35 35 35 65 50 80 C65 65 65 35 50 20"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <circle cx="50" cy="50" r="3" fill="currentColor" />
  </svg>
);

// Metatron's Cube simplified
export const MetatronIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Outer hexagon */}
    <polygon
      points="50,5 93,27.5 93,72.5 50,95 7,72.5 7,27.5"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
    />
    {/* Inner hexagon */}
    <polygon
      points="50,20 78,35 78,65 50,80 22,65 22,35"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
      opacity="0.7"
    />
    {/* Center */}
    <circle cx="50" cy="50" r="12" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="50" cy="50" r="4" fill="currentColor" />
    {/* Connecting lines */}
    <line x1="50" y1="5" x2="50" y2="20" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    <line x1="50" y1="80" x2="50" y2="95" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    <line x1="7" y1="27.5" x2="22" y2="35" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    <line x1="93" y1="27.5" x2="78" y2="35" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    <line x1="7" y1="72.5" x2="22" y2="65" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    <line x1="93" y1="72.5" x2="78" y2="65" stroke="currentColor" strokeWidth="1" opacity="0.5" />
  </svg>
);

// Lotus Flower - Enlightenment
export const LotusIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Center petal */}
    <path
      d="M50 15 C55 30 55 45 50 55 C45 45 45 30 50 15"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
    />
    {/* Side petals */}
    <path
      d="M30 25 C40 35 45 50 40 60 C30 50 25 35 30 25"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
    />
    <path
      d="M70 25 C60 35 55 50 60 60 C70 50 75 35 70 25"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
    />
    {/* Outer petals */}
    <path
      d="M15 40 C30 45 40 55 35 70 C20 60 10 50 15 40"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      opacity="0.7"
    />
    <path
      d="M85 40 C70 45 60 55 65 70 C80 60 90 50 85 40"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      opacity="0.7"
    />
    {/* Base */}
    <path
      d="M25 75 C35 70 50 68 50 68 C50 68 65 70 75 75"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <path
      d="M30 82 C40 78 50 76 50 76 C50 76 60 78 70 82"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      opacity="0.7"
    />
  </svg>
);

// Ancient Sun Symbol
export const AncientSunIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Center sun */}
    <circle cx="50" cy="50" r="20" stroke="currentColor" strokeWidth="2" fill="none" />
    <circle cx="50" cy="50" r="10" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="50" cy="50" r="4" fill="currentColor" />
    
    {/* Sun rays - wavy ancient style */}
    {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => {
      const rad = (angle * Math.PI) / 180;
      const x1 = 50 + 25 * Math.cos(rad);
      const y1 = 50 + 25 * Math.sin(rad);
      const x2 = 50 + 45 * Math.cos(rad);
      const y2 = 50 + 45 * Math.sin(rad);
      return (
        <line
          key={i}
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke="currentColor"
          strokeWidth={i % 2 === 0 ? "2" : "1.5"}
          strokeLinecap="round"
          opacity={i % 2 === 0 ? 1 : 0.7}
        />
      );
    })}
  </svg>
);

// Infinity Knot - Celtic inspired
export const EternalKnotIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    <path
      d="M20 50 C20 30 35 20 50 20 C65 20 80 30 80 50 C80 70 65 80 50 80 C35 80 20 70 20 50"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <path
      d="M30 50 C30 38 40 30 50 30 C60 30 70 38 70 50 C70 62 60 70 50 70 C40 70 30 62 30 50"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      opacity="0.7"
    />
    {/* Infinity symbol inside */}
    <path
      d="M35 50 C35 42 42 42 50 50 C58 58 65 58 65 50 C65 42 58 42 50 50 C42 58 35 58 35 50"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <circle cx="50" cy="50" r="3" fill="currentColor" />
  </svg>
);

// Triquetra - Trinity knot
export const TriquetraIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    <path
      d="M50 10 C30 25 20 50 50 70 C20 50 30 75 50 90 C70 75 80 50 50 70 C80 50 70 25 50 10"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <circle cx="50" cy="50" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="50" cy="50" r="3" fill="currentColor" />
  </svg>
);

// Compass Rose - Navigation/Direction
export const CompassIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    <circle cx="50" cy="50" r="45" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.3" />
    <circle cx="50" cy="50" r="35" stroke="currentColor" strokeWidth="1.5" fill="none" />
    
    {/* Main compass points */}
    <polygon points="50,8 45,40 50,50 55,40" fill="currentColor" />
    <polygon points="50,92 45,60 50,50 55,60" stroke="currentColor" strokeWidth="1" fill="none" />
    <polygon points="8,50 40,45 50,50 40,55" stroke="currentColor" strokeWidth="1" fill="none" />
    <polygon points="92,50 60,45 50,50 60,55" fill="currentColor" opacity="0.7" />
    
    {/* Inner circle */}
    <circle cx="50" cy="50" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="50" cy="50" r="3" fill="currentColor" />
  </svg>
);

// M.ai.ry Icon - Wisdom eye with lotus and sacred geometry
export const MairyIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Outer aura rings */}
    <circle cx="50" cy="50" r="46" stroke="currentColor" strokeWidth="0.5" fill="none" opacity="0.2" />
    <circle cx="50" cy="50" r="42" stroke="currentColor" strokeWidth="0.5" fill="none" opacity="0.3" />
    
    {/* Lotus petals - top */}
    <path d="M50 8 C45 20 40 28 50 35 C60 28 55 20 50 8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M30 18 C35 28 38 35 50 35 C42 30 38 22 30 18" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    <path d="M70 18 C65 28 62 35 50 35 C58 30 62 22 70 18" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    
    {/* Lotus petals - bottom */}
    <path d="M50 92 C45 80 40 72 50 65 C60 72 55 80 50 92" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M30 82 C35 72 38 65 50 65 C42 70 38 78 30 82" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    <path d="M70 82 C65 72 62 65 50 65 C58 70 62 78 70 82" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    
    {/* Side lotus petals */}
    <path d="M8 50 C20 45 28 40 35 50 C28 60 20 55 8 50" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    <path d="M92 50 C80 45 72 40 65 50 C72 60 80 55 92 50" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    
    {/* Central eye shape */}
    <ellipse cx="50" cy="50" rx="22" ry="14" stroke="currentColor" strokeWidth="2" fill="none" />
    
    {/* Inner iris */}
    <circle cx="50" cy="50" r="10" stroke="currentColor" strokeWidth="1.5" fill="none" />
    
    {/* Pupil with light reflection */}
    <circle cx="50" cy="50" r="5" fill="currentColor" />
    <circle cx="47" cy="47" r="1.5" fill="currentColor" opacity="0.3" />
    
    {/* Wisdom rays from eye */}
    <line x1="28" y1="50" x2="18" y2="50" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.5" />
    <line x1="72" y1="50" x2="82" y2="50" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.5" />
    <line x1="50" y1="36" x2="50" y2="28" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.5" />
    <line x1="50" y1="64" x2="50" y2="72" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.5" />
    
    {/* Diagonal rays */}
    <line x1="35" y1="40" x2="28" y2="33" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" opacity="0.4" />
    <line x1="65" y1="40" x2="72" y2="33" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" opacity="0.4" />
    <line x1="35" y1="60" x2="28" y2="67" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" opacity="0.4" />
    <line x1="65" y1="60" x2="72" y2="67" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" opacity="0.4" />
  </svg>
);

// ============ NEW TOOLS PANEL ICONS ============

// Belonging Tools Icon - Interlocking hearts/hands
export const BelongingToolsIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Central heart shape */}
    <path
      d="M50 85 C20 60 10 35 30 20 C40 12 50 20 50 30 C50 20 60 12 70 20 C90 35 80 60 50 85"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    {/* Inner heart */}
    <path
      d="M50 65 C35 52 30 40 40 32 C45 28 50 32 50 38 C50 32 55 28 60 32 C70 40 65 52 50 65"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      opacity="0.7"
    />
    {/* Connecting circles - hands/people */}
    <circle cx="25" cy="35" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="75" cy="35" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="50" cy="18" r="6" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7" />
    {/* Pulse from center */}
    <circle cx="50" cy="45" r="4" fill="currentColor" opacity="0.5" />
  </svg>
);

// Consent Flow Icon - Circle with check/hands raised
export const ConsentFlowIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Outer circle - the circle */}
    <circle cx="50" cy="50" r="42" stroke="currentColor" strokeWidth="2" fill="none" />
    {/* Inner dashed circle - process */}
    <circle cx="50" cy="50" r="32" stroke="currentColor" strokeWidth="1" fill="none" strokeDasharray="6 4" opacity="0.6" />
    
    {/* Three figures in consent position */}
    <g opacity="0.9">
      {/* Top figure */}
      <circle cx="50" cy="25" r="6" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <line x1="50" y1="31" x2="50" y2="42" stroke="currentColor" strokeWidth="1.5" />
      
      {/* Left figure */}
      <circle cx="28" cy="65" r="6" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <line x1="28" y1="71" x2="28" y2="82" stroke="currentColor" strokeWidth="1.5" />
      
      {/* Right figure */}
      <circle cx="72" cy="65" r="6" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <line x1="72" y1="71" x2="72" y2="82" stroke="currentColor" strokeWidth="1.5" />
    </g>
    
    {/* Central check/consent symbol */}
    <path
      d="M42 50 L48 56 L60 44"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    
    {/* Connecting arcs */}
    <path
      d="M38 40 Q50 35 62 40"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
      opacity="0.5"
    />
  </svg>
);

// Federation Icon - Connected nodes/planets
export const FederationIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Central node - larger */}
    <circle cx="50" cy="50" r="12" stroke="currentColor" strokeWidth="2" fill="none" />
    <circle cx="50" cy="50" r="5" fill="currentColor" opacity="0.7" />
    
    {/* Orbital ring */}
    <ellipse cx="50" cy="50" rx="38" ry="20" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.4" transform="rotate(30 50 50)" />
    <ellipse cx="50" cy="50" rx="38" ry="20" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.4" transform="rotate(-30 50 50)" />
    
    {/* Satellite nodes */}
    <circle cx="20" cy="30" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="20" cy="30" r="3" fill="currentColor" opacity="0.5" />
    
    <circle cx="80" cy="30" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="80" cy="30" r="3" fill="currentColor" opacity="0.5" />
    
    <circle cx="20" cy="70" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="20" cy="70" r="3" fill="currentColor" opacity="0.5" />
    
    <circle cx="80" cy="70" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="80" cy="70" r="3" fill="currentColor" opacity="0.5" />
    
    {/* Connection lines */}
    <line x1="28" y1="33" x2="38" y2="45" stroke="currentColor" strokeWidth="1" opacity="0.6" />
    <line x1="72" y1="33" x2="62" y2="45" stroke="currentColor" strokeWidth="1" opacity="0.6" />
    <line x1="28" y1="67" x2="38" y2="55" stroke="currentColor" strokeWidth="1" opacity="0.6" />
    <line x1="72" y1="67" x2="62" y2="55" stroke="currentColor" strokeWidth="1" opacity="0.6" />
  </svg>
);

// ElchmE Color Phase Icons
export const ElchmeBlueIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Eye for observation */}
    <ellipse cx="50" cy="50" rx="35" ry="22" stroke="currentColor" strokeWidth="2" fill="none" />
    <circle cx="50" cy="50" r="15" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="50" cy="50" r="6" fill="currentColor" />
    <circle cx="45" cy="45" r="2" fill="currentColor" opacity="0.3" />
  </svg>
);

export const ElchmeRedIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Heart for feeling */}
    <path
      d="M50 85 C15 55 5 30 30 15 C42 8 50 18 50 28 C50 18 58 8 70 15 C95 30 85 55 50 85"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    {/* Pulse line */}
    <path
      d="M25 50 L40 50 L45 35 L50 65 L55 35 L60 50 L75 50"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export const ElchmeGreenIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Root/tree for needs */}
    <path d="M50 20 L50 80" stroke="currentColor" strokeWidth="3" />
    <path d="M50 80 C35 75 25 85 20 95" stroke="currentColor" strokeWidth="2" fill="none" />
    <path d="M50 80 C65 75 75 85 80 95" stroke="currentColor" strokeWidth="2" fill="none" />
    <path d="M50 50 C35 45 25 50 20 45" stroke="currentColor" strokeWidth="2" fill="none" />
    <path d="M50 50 C65 45 75 50 80 45" stroke="currentColor" strokeWidth="2" fill="none" />
    <path d="M50 35 C40 30 35 35 30 30" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M50 35 C60 30 65 35 70 30" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="50" cy="15" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
  </svg>
);

export const ElchmeGoldIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Star/sun for gold resolution */}
    <circle cx="50" cy="50" r="15" stroke="currentColor" strokeWidth="2" fill="none" />
    <circle cx="50" cy="50" r="6" fill="currentColor" />
    {/* Rays */}
    {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => {
      const rad = (angle * Math.PI) / 180;
      const x1 = 50 + 20 * Math.cos(rad);
      const y1 = 50 + 20 * Math.sin(rad);
      const x2 = 50 + 40 * Math.cos(rad);
      const y2 = 50 + 40 * Math.sin(rad);
      return (
        <line
          key={i}
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke="currentColor"
          strokeWidth={i % 2 === 0 ? "2.5" : "1.5"}
          strokeLinecap="round"
        />
      );
    })}
  </svg>
);

// Soul & Signal Icon (North)
export const SoulSignalIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Signal waves */}
    <path d="M50 70 Q50 55 50 40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M35 65 Q50 50 65 65" stroke="currentColor" strokeWidth="1.5" fill="none" opacity="0.8" />
    <path d="M25 72 Q50 52 75 72" stroke="currentColor" strokeWidth="1.5" fill="none" opacity="0.6" />
    <path d="M15 80 Q50 55 85 80" stroke="currentColor" strokeWidth="1.5" fill="none" opacity="0.4" />
    {/* Star/soul at top */}
    <polygon points="50,10 53,25 65,25 55,33 58,48 50,40 42,48 45,33 35,25 47,25" fill="currentColor" />
  </svg>
);

// Team Mode Icon - Interconnected souls/circles (collaborative)
export const TeamModeIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Three interconnected souls forming a triangle */}
    <circle cx="50" cy="22" r="14" stroke="currentColor" strokeWidth="2" fill="none" />
    <circle cx="50" cy="22" r="5" fill="currentColor" opacity="0.6" />
    
    <circle cx="26" cy="68" r="14" stroke="currentColor" strokeWidth="2" fill="none" />
    <circle cx="26" cy="68" r="5" fill="currentColor" opacity="0.6" />
    
    <circle cx="74" cy="68" r="14" stroke="currentColor" strokeWidth="2" fill="none" />
    <circle cx="74" cy="68" r="5" fill="currentColor" opacity="0.6" />
    
    {/* Connecting lines - the bonds */}
    <line x1="50" y1="36" x2="32" y2="56" stroke="currentColor" strokeWidth="1.5" opacity="0.7" />
    <line x1="50" y1="36" x2="68" y2="56" stroke="currentColor" strokeWidth="1.5" opacity="0.7" />
    <line x1="40" y1="68" x2="60" y2="68" stroke="currentColor" strokeWidth="1.5" opacity="0.7" />
    
    {/* Central heart/unity symbol */}
    <path 
      d="M50 45 C45 40 38 42 38 48 C38 54 50 62 50 62 C50 62 62 54 62 48 C62 42 55 40 50 45"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      opacity="0.5"
    />
  </svg>
);

// Simple Mode Icon - Single focused quill/pen (solo writing)
export const SimpleModeIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Quill feather */}
    <path 
      d="M75 10 C55 25 45 45 35 75 C35 75 45 70 50 65 C55 60 58 55 60 50 C62 45 65 38 75 10"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    {/* Feather spine */}
    <path 
      d="M75 10 C60 30 50 50 38 78"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
    />
    {/* Quill tip */}
    <path 
      d="M38 78 L32 92 L42 85"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    {/* Feather barbs */}
    <path d="M65 25 C58 28 55 32 52 38" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    <path d="M58 35 C52 38 48 44 45 52" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    <path d="M52 45 C47 50 44 56 42 64" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    {/* Ink drop */}
    <circle cx="32" cy="92" r="3" fill="currentColor" opacity="0.8" />
  </svg>
);

// Sacred Founder Icon - Unique to Bliss Abode Startup Studio
// Combines 8-point compass rose with seed of life and central flame
export const SacredFounderIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}>
    {/* Outer sacred circle */}
    <circle cx="50" cy="50" r="46" stroke="currentColor" strokeWidth="0.75" fill="none" opacity="0.2" />
    <circle cx="50" cy="50" r="42" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.3" />
    
    {/* 8-point compass rose - outer points */}
    {/* Cardinal points */}
    <path d="M50 5 L46 25 L50 30 L54 25 Z" fill="currentColor" opacity="0.9" />
    <path d="M50 95 L46 75 L50 70 L54 75 Z" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.6" />
    <path d="M5 50 L25 46 L30 50 L25 54 Z" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.6" />
    <path d="M95 50 L75 46 L70 50 L75 54 Z" fill="currentColor" opacity="0.7" />
    
    {/* Intercardinal points - smaller, elegant */}
    <path d="M18 18 L30 28 L32 32 L28 30 Z" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.5" />
    <path d="M82 18 L70 28 L68 32 L72 30 Z" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.5" />
    <path d="M18 82 L30 72 L32 68 L28 70 Z" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.5" />
    <path d="M82 82 L70 72 L68 68 L72 70 Z" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.5" />
    
    {/* Seed of life pattern - inner circles */}
    <circle cx="50" cy="50" r="18" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.6" />
    <circle cx="50" cy="38" r="10" stroke="currentColor" strokeWidth="0.75" fill="none" opacity="0.4" />
    <circle cx="50" cy="62" r="10" stroke="currentColor" strokeWidth="0.75" fill="none" opacity="0.4" />
    <circle cx="38" cy="50" r="10" stroke="currentColor" strokeWidth="0.75" fill="none" opacity="0.4" />
    <circle cx="62" cy="50" r="10" stroke="currentColor" strokeWidth="0.75" fill="none" opacity="0.4" />
    
    {/* Central flame/seed - the spark of creation */}
    <path 
      d="M50 35 C45 42 42 48 50 58 C58 48 55 42 50 35"
      fill="currentColor"
      opacity="0.8"
    />
    <path 
      d="M50 40 C47 45 46 50 50 55 C54 50 53 45 50 40"
      fill="currentColor"
      opacity="0.4"
    />
    
    {/* Inner glow ring */}
    <circle cx="50" cy="50" r="8" stroke="currentColor" strokeWidth="0.5" fill="none" opacity="0.4" />
  </svg>
);

// Brand Name Checker Icon - A stylized trademark/badge symbol
export const BrandCheckerIcon = ({ size = 24, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    {/* Shield/Badge shape */}
    <path 
      d="M12 2L4 6v6c0 5.55 3.84 10.74 8 12 4.16-1.26 8-6.45 8-12V6l-8-4z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      fill="currentColor" 
      fillOpacity="0.1"
    />
    {/* TM letters */}
    <text 
      x="12" 
      y="14" 
      textAnchor="middle" 
      fontSize="8" 
      fontWeight="bold" 
      fill="currentColor"
    >
      ™
    </text>
    {/* Sparkle accent */}
    <circle cx="17" cy="5" r="1.5" fill="currentColor" fillOpacity="0.6" />
  </svg>
);

// Emergency SOS Icon - A glowing heart with pulse
export const EmergencySOSIcon = ({ size = 24, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    {/* Glowing circle */}
    <circle 
      cx="12" 
      cy="12" 
      r="10" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      fill="currentColor" 
      fillOpacity="0.15"
    />
    {/* Heart shape */}
    <path 
      d="M12 7.5c1.5-1.5 4-1.5 4 1s-4 5.5-4 5.5S8 11 8 8.5s2.5-2.5 4-1z" 
      fill="currentColor"
    />
    {/* Pulse line */}
    <path 
      d="M3 12h3l1.5-2 2 4 1.5-2h3" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

// Whimsical Tome/Book Icon with magical elements
export const TomeMachineIcon = ({ size = 24, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    {/* Open book base */}
    <path 
      d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      fill="currentColor" 
      fillOpacity="0.1"
    />
    <path 
      d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      fill="currentColor" 
      fillOpacity="0.1"
    />
    {/* Magical sparkles */}
    <circle cx="6" cy="8" r="1" fill="currentColor" fillOpacity="0.6" />
    <circle cx="18" cy="8" r="1" fill="currentColor" fillOpacity="0.6" />
    <circle cx="12" cy="4" r="1.5" fill="currentColor" fillOpacity="0.8" />
    {/* Quill/feather accent */}
    <path 
      d="M19 2c-2 2-2 4-2 6s2 2 2 2" 
      stroke="currentColor" 
      strokeWidth="1" 
      strokeLinecap="round"
      fill="none"
      opacity="0.6"
    />
    {/* Center spine glow */}
    <path 
      d="M12 7v11" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round"
      opacity="0.4"
    />
  </svg>
);

// Story Compass Rose - Whimsical 8-point compass for storytelling
export const StoryCompassIcon = ({ size = 24, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    {/* Outer circle */}
    <circle 
      cx="12" 
      cy="12" 
      r="10" 
      stroke="currentColor" 
      strokeWidth="1" 
      fill="currentColor" 
      fillOpacity="0.05"
    />
    {/* Inner circle */}
    <circle 
      cx="12" 
      cy="12" 
      r="3" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      fill="currentColor" 
      fillOpacity="0.2"
    />
    {/* 8 compass points */}
    <path d="M12 2v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 18v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M2 12h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M18 12h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    {/* Diagonal points */}
    <path d="M4.93 4.93l2.83 2.83" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M16.24 16.24l2.83 2.83" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M4.93 19.07l2.83-2.83" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M16.24 7.76l2.83-2.83" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    {/* Decorative dots at cardinal points */}
    <circle cx="12" cy="2" r="1" fill="currentColor" />
    <circle cx="12" cy="22" r="1" fill="currentColor" />
    <circle cx="2" cy="12" r="1" fill="currentColor" />
    <circle cx="22" cy="12" r="1" fill="currentColor" />
  </svg>
);

// Also export MandalaIcon as LegendaryIcon for convenience
export const LegendaryIcon = MandalaIcon;

// ============ TOME MACHINE SPECIFIC ICONS ============

// Genesis/Lightbulb - Spark of creation
export const GenesisSparkIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Flame/spark core */}
    <path 
      d="M12 3C10 7 8 9 8 13a4 4 0 0 0 8 0c0-4-2-6-4-10z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      fill="currentColor" 
      fillOpacity="0.2"
    />
    {/* Inner flame */}
    <path 
      d="M12 8c-1 2-2 3-2 5a2 2 0 0 0 4 0c0-2-1-3-2-5z" 
      fill="currentColor" 
      fillOpacity="0.6"
    />
    {/* Radiating wisps */}
    <path d="M5 10c1-1 2-2 3-2" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.5" />
    <path d="M19 10c-1-1-2-2-3-2" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.5" />
    {/* Base glow */}
    <path d="M9 18h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M10 20h4" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.6" />
  </svg>
);

// Character/Soul - Twin souls icon
export const SoulMirrorIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Two connected figures/souls */}
    <circle cx="8" cy="7" r="3" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M8 10v4c0 1 1 2 2 2h4c1 0 2-1 2-2v-4" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="16" cy="7" r="3" stroke="currentColor" strokeWidth="1.5" fill="none" />
    {/* Heart connection */}
    <path d="M12 12v3" stroke="currentColor" strokeWidth="1" opacity="0.6" />
    <path d="M10 19l2-2 2 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    {/* Aura */}
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="0.5" fill="none" opacity="0.3" />
  </svg>
);

// World/Realm - Sacred landscape
export const RealmGateIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Archway/portal */}
    <path 
      d="M4 21V8a8 8 0 0 1 16 0v13" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      fill="none"
    />
    {/* Inner arch */}
    <path 
      d="M7 21V10a5 5 0 0 1 10 0v11" 
      stroke="currentColor" 
      strokeWidth="1" 
      fill="currentColor" 
      fillOpacity="0.1"
    />
    {/* Path/road leading in */}
    <path d="M10 21l2-4 2 4" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.6" />
    {/* Sun/star at top */}
    <circle cx="12" cy="7" r="2" fill="currentColor" fillOpacity="0.6" />
    {/* Stars */}
    <circle cx="8" cy="5" r="0.5" fill="currentColor" />
    <circle cx="16" cy="5" r="0.5" fill="currentColor" />
  </svg>
);

// Conflict/Challenge - Crossed swords/flame
export const ConflictFireIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Flame base */}
    <path 
      d="M12 2c-2 4-4 6-4 10a4 4 0 0 0 8 0c0-4-2-6-4-10z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      fill="currentColor" 
      fillOpacity="0.3"
    />
    {/* Inner flame */}
    <path d="M12 6c-1 2-2 3-2 5a2 2 0 0 0 4 0c0-2-1-3-2-5z" fill="currentColor" fillOpacity="0.6" />
    {/* Crossed elements */}
    <path d="M6 18l4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M18 18l-4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    {/* Sparks */}
    <circle cx="7" cy="8" r="0.75" fill="currentColor" />
    <circle cx="17" cy="8" r="0.75" fill="currentColor" />
    <circle cx="12" cy="20" r="1" fill="currentColor" opacity="0.5" />
  </svg>
);

// Structure/Blueprint - Sacred scroll with geometry
export const SacredScrollIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Scroll body */}
    <path 
      d="M6 3c-1 0-2 1-2 2v14c0 1 1 2 2 2h12c1 0 2-1 2-2V5c0-1-1-2-2-2H6z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      fill="currentColor" 
      fillOpacity="0.1"
    />
    {/* Scroll top curl */}
    <path d="M4 6c0-2 1-3 3-3h10c2 0 3 1 3 3" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    {/* Sacred geometry inside */}
    <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.6" />
    <path d="M12 8v8" stroke="currentColor" strokeWidth="0.75" opacity="0.5" />
    <path d="M8 12h8" stroke="currentColor" strokeWidth="0.75" opacity="0.5" />
    {/* Lines representing text */}
    <path d="M8 17h8" stroke="currentColor" strokeWidth="0.75" opacity="0.4" />
    <path d="M9 19h6" stroke="currentColor" strokeWidth="0.75" opacity="0.3" />
  </svg>
);

// Voice/Craft - Quill with music note essence
export const VoiceQuillIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Quill feather */}
    <path 
      d="M20 2c-4 4-6 8-8 14l-2 4 3-1c2-4 4-10 7-17z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      fill="currentColor" 
      fillOpacity="0.2"
    />
    {/* Feather spine */}
    <path d="M19 3c-3 4-5 9-7 15" stroke="currentColor" strokeWidth="1" opacity="0.6" />
    {/* Feather barbs */}
    <path d="M17 6c-2 1-3 2-4 4" stroke="currentColor" strokeWidth="0.75" opacity="0.4" />
    <path d="M15 9c-2 1-3 3-3 5" stroke="currentColor" strokeWidth="0.75" opacity="0.4" />
    {/* Ink drop with swirl */}
    <circle cx="10" cy="20" r="2" stroke="currentColor" strokeWidth="1" fill="currentColor" fillOpacity="0.4" />
    <path d="M6 16c1 0 2 1 2 2" stroke="currentColor" strokeWidth="0.75" opacity="0.5" />
  </svg>
);

// Emotion/Heart - Sacred heart with radiating love
export const SacredHeartIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Outer glow */}
    <path 
      d="M12 21C5 16 2 11 2 7.5a5.5 5.5 0 0 1 10-3 5.5 5.5 0 0 1 10 3c0 3.5-3 8.5-10 13.5z" 
      stroke="currentColor" 
      strokeWidth="0.75" 
      fill="none" 
      opacity="0.3"
    />
    {/* Main heart */}
    <path 
      d="M12 19C6 14 4 10 4 7.5a4.5 4.5 0 0 1 8-2.8 4.5 4.5 0 0 1 8 2.8c0 2.5-2 6.5-8 11.5z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      fill="currentColor" 
      fillOpacity="0.2"
    />
    {/* Inner glow */}
    <path 
      d="M12 15c-3-2.5-4-5-4-6.5a2.5 2.5 0 0 1 4-2 2.5 2.5 0 0 1 4 2c0 1.5-1 4-4 6.5z" 
      fill="currentColor" 
      fillOpacity="0.4"
    />
    {/* Radiating lines */}
    <path d="M12 4v-2" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.5" />
    <path d="M18 6l1.5-1.5" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" opacity="0.4" />
    <path d="M6 6l-1.5-1.5" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" opacity="0.4" />
  </svg>
);

// Vision/Legacy - Eye with compass/star
export const VisionaryEyeIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Eye shape */}
    <path 
      d="M2 12c2-4 5-7 10-7s8 3 10 7c-2 4-5 7-10 7s-8-3-10-7z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      fill="currentColor" 
      fillOpacity="0.1"
    />
    {/* Iris */}
    <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5" fill="none" />
    {/* Pupil with star */}
    <circle cx="12" cy="12" r="2" fill="currentColor" />
    {/* Vision rays */}
    <path d="M12 5v-2" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.4" />
    <path d="M12 21v-2" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.4" />
    {/* Sparkle */}
    <circle cx="10" cy="10" r="0.5" fill="currentColor" opacity="0.5" />
  </svg>
);

// Novel/Book - Ancient tome
export const AncientTomeIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Book cover */}
    <path 
      d="M4 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      fill="currentColor" 
      fillOpacity="0.1"
    />
    {/* Spine decoration */}
    <path d="M7 2v20" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    {/* Sacred symbol on cover */}
    <circle cx="13" cy="10" r="3" stroke="currentColor" strokeWidth="1" fill="none" />
    <circle cx="13" cy="10" r="1" fill="currentColor" fillOpacity="0.5" />
    {/* Page lines */}
    <path d="M10 15h6" stroke="currentColor" strokeWidth="0.75" opacity="0.4" />
    <path d="M10 17h5" stroke="currentColor" strokeWidth="0.75" opacity="0.3" />
  </svg>
);

// Film/Screenplay - Film reel with sacred geometry
export const SacredReelIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Outer reel */}
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.1" />
    {/* Inner circle */}
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5" fill="none" />
    {/* Film holes - sacred arrangement */}
    <circle cx="12" cy="5" r="1.5" fill="currentColor" fillOpacity="0.6" />
    <circle cx="12" cy="19" r="1.5" fill="currentColor" fillOpacity="0.6" />
    <circle cx="5" cy="12" r="1.5" fill="currentColor" fillOpacity="0.6" />
    <circle cx="19" cy="12" r="1.5" fill="currentColor" fillOpacity="0.6" />
    {/* Diagonal holes */}
    <circle cx="7" cy="7" r="1" fill="currentColor" fillOpacity="0.4" />
    <circle cx="17" cy="7" r="1" fill="currentColor" fillOpacity="0.4" />
    <circle cx="7" cy="17" r="1" fill="currentColor" fillOpacity="0.4" />
    <circle cx="17" cy="17" r="1" fill="currentColor" fillOpacity="0.4" />
    {/* Center dot */}
    <circle cx="12" cy="12" r="1" fill="currentColor" />
  </svg>
);

// Introspection/Brain - Third eye/mind
export const ThirdEyeIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Head outline */}
    <path 
      d="M12 2a9 9 0 0 1 9 9c0 3-1.5 5-3 7l-1 2H7l-1-2c-1.5-2-3-4-3-7a9 9 0 0 1 9-9z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      fill="currentColor" 
      fillOpacity="0.1"
    />
    {/* Third eye */}
    <ellipse cx="12" cy="10" rx="4" ry="2.5" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="12" cy="10" r="1.5" fill="currentColor" />
    {/* Enlightenment rays */}
    <path d="M12 4v-1" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.5" />
    <path d="M8 5l-.5-1" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" opacity="0.4" />
    <path d="M16 5l.5-1" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" opacity="0.4" />
    {/* Base */}
    <path d="M8 20h8" stroke="currentColor" strokeWidth="1" opacity="0.6" />
  </svg>
);

// Navigation arrows - Sacred chevrons
export const SacredChevronRight = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 9l3 3-3 3" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" opacity="0.4" />
  </svg>
);

export const SacredChevronLeft = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 9l-3 3 3 3" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" opacity="0.4" />
  </svg>
);

// Check mark - Sacred checkmark
export const SacredCheckIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1" fill="currentColor" fillOpacity="0.1" opacity="0.5" />
    <path d="M7 12l3 3 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Plus/Add - Sacred plus
export const SacredPlusIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1" fill="currentColor" fillOpacity="0.05" opacity="0.4" />
    <path d="M12 7v10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M7 12h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// Refresh/Generate - Sacred spiral
export const SacredSpiralIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path 
      d="M12 2a10 10 0 0 1 10 10" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round"
    />
    <path 
      d="M12 22a10 10 0 0 1-10-10" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round"
    />
    <path d="M22 12l-2-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M22 12l-2 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M2 12l2 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M2 12l2-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1" fill="currentColor" fillOpacity="0.3" />
  </svg>
);

// Magic/Sparkles - Sacred stars
export const SacredSparklesIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Main star */}
    <path d="M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5L12 2z" fill="currentColor" />
    {/* Secondary star */}
    <path d="M19 14l0.75 2.25L22 17l-2.25 0.75L19 20l-0.75-2.25L16 17l2.25-0.75L19 14z" fill="currentColor" fillOpacity="0.7" />
    {/* Tertiary star */}
    <path d="M5 16l0.5 1.5L7 18l-1.5 0.5L5 20l-0.5-1.5L3 18l1.5-0.5L5 16z" fill="currentColor" fillOpacity="0.5" />
  </svg>
);

// Download - Sacred descent
export const SacredDownloadIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M12 3v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M8 11l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    {/* Sacred base */}
    <path d="M8 21h8" stroke="currentColor" strokeWidth="1" opacity="0.5" />
  </svg>
);

// Copy - Sacred duplication
export const SacredCopyIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="8" y="8" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.1" />
    <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" stroke="currentColor" strokeWidth="1.5" />
    {/* Inner symbol */}
    <circle cx="14" cy="14" r="2" stroke="currentColor" strokeWidth="0.75" fill="none" opacity="0.5" />
  </svg>
);

// Menu - Sacred three lines
export const SacredMenuIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M4 7h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M4 12h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M4 17h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    {/* Decorative dots */}
    <circle cx="2" cy="7" r="0.75" fill="currentColor" opacity="0.4" />
    <circle cx="2" cy="12" r="0.75" fill="currentColor" opacity="0.4" />
    <circle cx="2" cy="17" r="0.75" fill="currentColor" opacity="0.4" />
  </svg>
);

// Close X - Sacred close
export const SacredCloseIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.3" />
    <path d="M8 8l8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M16 8l-8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// Panel toggle icons
export const SacredPanelOpenIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M15 3v18" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    <path d="M9 9l3 3-3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SacredPanelCloseIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M15 3v18" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    <path d="M11 9l-3 3 3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);


// List View - Sacred scrolls
export const SacredListIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="3" y="4" width="18" height="4" rx="1" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.15" />
    <rect x="3" y="10" width="18" height="4" rx="1" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.1" />
    <rect x="3" y="16" width="18" height="4" rx="1" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.05" />
  </svg>
);

// Focus Mode - Sacred eye/center
export const SacredFocusIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.3" />
    <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.1" />
    <circle cx="12" cy="12" r="2" fill="currentColor" />
    {/* Focus lines */}
    <path d="M12 2v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 19v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M2 12h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M19 12h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
